import Phaser from "phaser";
import type { BaseToast } from "@phaser/ui/toast/BaseToast";
import { AlertToast } from "@phaser/ui/toast/AlertToast";

export const ToastType = {
  ALERT: "ALERT",
} as const;

export type ToastType = (typeof ToastType)[keyof typeof ToastType];

export interface AlertToastPayload {
  message: string;
  onClose?: () => void;
}

export class ToastManager {
  private scene: Phaser.Scene;
  private current?: BaseToast;

  constructor(scene: Phaser.Scene) {
    this.scene = scene;
  }

  open(type: ToastType, payload?: AlertToastPayload) {
    const { width, height } = this.scene.scale;

    // 이미 떠 있는 토스트가 있으면 교체
    this.close();

    switch (type) {
      case ToastType.ALERT:
        if (!payload || !("message" in payload)) {
          throw new Error("ToastManager: payload is required for ALERT toast.");
        }

        this.current = new AlertToast(
          this.scene,
          width / 2,
          height / 2,
          payload.message,
          () => {
            payload.onClose?.();
            this.current = undefined;
          },
        );
        break;

      default:
        throw new Error(`Unknown toast type: ${type}`);
    }

    this.current.open();
  }

  close() {
    if (!this.current) return;
    this.current.close();
    this.current = undefined;
  }

  isOpen() {
    return !!this.current;
  }
}
